"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment LinkList on EditorialLinkList {\n    __typename\n    id\n    title\n    linkItems {\n      __typename\n      downloadable\n      title\n      link {\n        __typename\n        id\n        relativeUrl\n        title\n        type\n        appLink {\n          __typename\n          link\n          deepLink\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.linkListFragment = void 0;
var _fetching = require("@ori/fetching");
const linkListFragment = exports.linkListFragment = (0, _fetching.gql)(_templateObject());
